import React, { useRef } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { StickyDataTable } from "../../general/DataTable/StickyDataTable";
import { TrialBalanceResponse } from "../../../common/contracts/accounting-reports";
import { TrialBalanceTable } from "./TrialBalanceTable";

interface Props {
    data: TrialBalanceResponse;
}

export const TrialBalanceTableContainer: React.FC<Props> = ({ data }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const scrollbarsRef = useRef<Scrollbars>(null);

    return (
        <div className="data-table" ref={containerRef}>
            <StickyDataTable
                containerRef={containerRef}
                ref={scrollbarsRef}
                stickyLeft
            >
                <TrialBalanceTable data={data} />
            </StickyDataTable>
        </div>
    );
};
